/**
 * Shared axios instance and API call helpers.
 *
 * All service modules import from here so that base URL, auth headers,
 * and interceptors are configured in exactly one place.
 */
import axiosInstance from '@/axios'

export default axiosInstance

/**
 * Wrapper that returns response.data directly and provides a single
 * place to add cross-cutting concerns (logging, error normalisation, etc.)
 * later without touching every service function.
 *
 * Usage:
 *   const campaigns = await apiCall('get', '/campaign/getCampaignList')
 *   const result    = await apiCall('post', '/auth/login', { login, password })
 */
export async function apiCall(method, url, data = null, config = {}) {
  let response
  if (method === 'get' || method === 'delete') {
    // GET/DELETE: data arg is treated as config (params, headers, etc.)
    response = await axiosInstance[method](url, data || config)
  } else {
    response = await axiosInstance[method](url, data, config)
  }
  return response.data
}
